import { compose } from '@bem-react/core';
import {
    Spin as SpinPresenter,
    withPositionCenter,
    withSizeM,
    withToneDefault,
    withViewDefault
} from '@yandex-lego/components/Spin/desktop';

const Spin = compose(
    withViewDefault,
    withToneDefault,
    withSizeM,
    withPositionCenter
)(SpinPresenter);

export default Spin;
